// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1400px) {
  .IndexNavbar_navItem__nnx1r {
    margin: 0.7rem;
    color: #2E2E2E !important;
    text-decoration: none;
    transition: color 0.3s, border-color 0.3s;
    border: 3px solid transparent;
    border-radius: 20px;
    padding: 13px;
    font-size: 17px; /* Taille de la police */
    font-family: 'Lato'; 
    font-weight: 500; /* Poids de la police */
  }
}

@media (max-width: 1399px) {
  .IndexNavbar_navItem__nnx1r {
    color: #2E2E2E !important;
    text-decoration: none;
    transition: color 0.3s, border-color 0.3s;
    border: 3px solid transparent;
    border-radius: 20px;
    font-size: 17px; /* Taille de la police */
    font-family: 'Lato'; 
    font-weight: 500; /* Poids de la police */
  }
}
  
  .IndexNavbar_navItem__nnx1r:hover {
    color: #4AAE9B !important;
    border-color: #4AAE9B !important;
    text-decoration: none;
    border-radius: 20px;
    cursor: pointer;
  }

  .IndexNavbar_navbarContainer__g-I9w {
    padding: 0.5rem;
  }
  
  @media (min-width: 758px) {
    .IndexNavbar_logo__42tA1 {
      max-width: 300px; /* Adjust as needed */
      gap: 10px;
    }
  }
  
  @media (max-width: 757px) {
    .IndexNavbar_logo__42tA1 {
      max-width: 200px; /* Adjust as needed */
      gap: 10px;
    }
  }

  .IndexNavbar_navContainer__Y8QOJ {
    gap: 20px;
  }
  
  .IndexNavbar_actionContainer__7du5e {
    gap: 10px;
    margin-left: 0 !important;
  }

  .IndexNavbar_activeNavItem__9N3wQ {
     color: #4AAE9B !important;
    font-weight: 700;
 }

 .IndexNavbar_avatar__XgoaU {
  height: 18px;
  width: 15px;
  margin-left: 14px;
  /* min-width: 50px;
  border-radius: 50px;
 
  border: 1px solid #dfe0eb; */
}

.IndexNavbar_dropdownItemText__gZj4h{
  font-size: 13px;
  color: black;
  margin: 0;
  font-weight: 600;
}

.IndexNavbar_connectItem__MAxgM{
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  margin-left: 15px;
}
.IndexNavbar_signupItem__Y84-s{
  cursor: pointer;
}

.IndexNavbar_custom-margin-left__TzNpH {
  margin-left: 20px; /* Ajoutez une marge à gauche au texte */
  white-space: nowrap; /* Empêche le texte de se rompre sur plusieurs lignes */

}

.IndexNavbar_icon-action__SKAgH {
  margin-right: 20px; /* Ajoutez une marge à droite à l'image */
}

/* .abonner_btn{
  background-color: #4AAE9B;
    color: white;
    padding: 10px;
    border-radius: 10px;
    cursor: pointer;
  font-weight: 500;
  margin: 0.7rem;
  transition: color 0.3s, border-color 0.3s;
  border-radius: 20px;
  font-size: 17px;
  font-family: 'Lato';
} */
`, "",{"version":3,"sources":["webpack://./src/Pages/IndexNavbar/IndexNavbar.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,yCAAyC;IACzC,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,eAAe,EAAE,wBAAwB;IACzC,mBAAmB;IACnB,gBAAgB,EAAE,uBAAuB;EAC3C;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,qBAAqB;IACrB,yCAAyC;IACzC,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe,EAAE,wBAAwB;IACzC,mBAAmB;IACnB,gBAAgB,EAAE,uBAAuB;EAC3C;AACF;;EAEE;IACE,yBAAyB;IACzB,gCAAgC;IAChC,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;MACE,gBAAgB,EAAE,qBAAqB;MACvC,SAAS;IACX;EACF;;EAEA;IACE;MACE,gBAAgB,EAAE,qBAAqB;MACvC,SAAS;IACX;EACF;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,yBAAyB;EAC3B;;EAEA;KACG,yBAAyB;IAC1B,gBAAgB;CACnB;;CAEA;EACC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB;;;8BAG4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB,EAAE,wCAAwC;EAC3D,mBAAmB,EAAE,uDAAuD;;AAE9E;;AAEA;EACE,kBAAkB,EAAE,yCAAyC;AAC/D;;AAEA;;;;;;;;;;;;GAYG","sourcesContent":["@media (min-width: 1400px) {\n  .navItem {\n    margin: 0.7rem;\n    color: #2E2E2E !important;\n    text-decoration: none;\n    transition: color 0.3s, border-color 0.3s;\n    border: 3px solid transparent;\n    border-radius: 20px;\n    padding: 13px;\n    font-size: 17px; /* Taille de la police */\n    font-family: 'Lato'; \n    font-weight: 500; /* Poids de la police */\n  }\n}\n\n@media (max-width: 1399px) {\n  .navItem {\n    color: #2E2E2E !important;\n    text-decoration: none;\n    transition: color 0.3s, border-color 0.3s;\n    border: 3px solid transparent;\n    border-radius: 20px;\n    font-size: 17px; /* Taille de la police */\n    font-family: 'Lato'; \n    font-weight: 500; /* Poids de la police */\n  }\n}\n  \n  .navItem:hover {\n    color: #4AAE9B !important;\n    border-color: #4AAE9B !important;\n    text-decoration: none;\n    border-radius: 20px;\n    cursor: pointer;\n  }\n\n  .navbarContainer {\n    padding: 0.5rem;\n  }\n  \n  @media (min-width: 758px) {\n    .logo {\n      max-width: 300px; /* Adjust as needed */\n      gap: 10px;\n    }\n  }\n  \n  @media (max-width: 757px) {\n    .logo {\n      max-width: 200px; /* Adjust as needed */\n      gap: 10px;\n    }\n  }\n\n  .navContainer {\n    gap: 20px;\n  }\n  \n  .actionContainer {\n    gap: 10px;\n    margin-left: 0 !important;\n  }\n\n  .activeNavItem {\n     color: #4AAE9B !important;\n    font-weight: 700;\n }\n\n .avatar {\n  height: 18px;\n  width: 15px;\n  margin-left: 14px;\n  /* min-width: 50px;\n  border-radius: 50px;\n \n  border: 1px solid #dfe0eb; */\n}\n\n.dropdownItemText{\n  font-size: 13px;\n  color: black;\n  margin: 0;\n  font-weight: 600;\n}\n\n.connectItem{\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  cursor: pointer;\n  margin-left: 15px;\n}\n.signupItem{\n  cursor: pointer;\n}\n\n.custom-margin-left {\n  margin-left: 20px; /* Ajoutez une marge à gauche au texte */\n  white-space: nowrap; /* Empêche le texte de se rompre sur plusieurs lignes */\n\n}\n\n.icon-action {\n  margin-right: 20px; /* Ajoutez une marge à droite à l'image */\n}\n\n/* .abonner_btn{\n  background-color: #4AAE9B;\n    color: white;\n    padding: 10px;\n    border-radius: 10px;\n    cursor: pointer;\n  font-weight: 500;\n  margin: 0.7rem;\n  transition: color 0.3s, border-color 0.3s;\n  border-radius: 20px;\n  font-size: 17px;\n  font-family: 'Lato';\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navItem": `IndexNavbar_navItem__nnx1r`,
	"navbarContainer": `IndexNavbar_navbarContainer__g-I9w`,
	"logo": `IndexNavbar_logo__42tA1`,
	"navContainer": `IndexNavbar_navContainer__Y8QOJ`,
	"actionContainer": `IndexNavbar_actionContainer__7du5e`,
	"activeNavItem": `IndexNavbar_activeNavItem__9N3wQ`,
	"avatar": `IndexNavbar_avatar__XgoaU`,
	"dropdownItemText": `IndexNavbar_dropdownItemText__gZj4h`,
	"connectItem": `IndexNavbar_connectItem__MAxgM`,
	"signupItem": `IndexNavbar_signupItem__Y84-s`,
	"custom-margin-left": `IndexNavbar_custom-margin-left__TzNpH`,
	"icon-action": `IndexNavbar_icon-action__SKAgH`
};
export default ___CSS_LOADER_EXPORT___;
